export default __webpack_public_path__ + "static/media/Dune-hd-5.f396c1ba.jpg";